import { useState } from "react";
import { Zap, History } from "lucide-react";
import ReglasList from "./ReglasList";
import HistorialNotificaciones from "./HistorialNotificaciones";

const TABS = [
  { id: "reglas", label: "Reglas", icon: Zap },
  { id: "historial", label: "Historial", icon: History },
];

export default function GestionReglas() {
  const [tab, setTab] = useState("reglas");

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Tab bar */}
      <div className="bg-white border-b border-gray-200 px-6">
        <div className="flex gap-0">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 px-5 py-4 text-sm font-medium border-b-2 transition ${
                  active
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                <Icon size={15} />
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      {tab === "reglas" && <ReglasList />}
      {tab === "historial" && <HistorialNotificaciones />}
    </div>
  );
}
